import React from 'react';
import * as S from './CollectionsList.styled';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const CollectionsListSkeleton = () => {
  return (
    <S.SkeletonContainer>
      <S.SkeletonListContainer>
        <SkeletonLoader borderRadius={14} height={76} />
        <SkeletonLoader borderRadius={14} height={76} />
        <SkeletonLoader borderRadius={14} height={76} />
      </S.SkeletonListContainer>
    </S.SkeletonContainer>
  );
};
